import React from "react";

import styles from "./PercentageDonutChart.scss";

export interface PercentageCircleProps {
  percent: number;
}

export function PercentageCircle({
  percent,
}: PercentageCircleProps): JSX.Element {
  const radius = 28.5;
  const circumference = 2 * Math.PI * radius;
  const percentageValue = percent > 1 ? 0 : circumference * (1 - percent);

  const circleProps = {
    cx: 32,
    cy: 32.5,
    fill: "none",
    r: radius,
    strokeWidth: "5",
  };

  return (
    <svg
      height="120"
      width="100%"
      className={styles.progress__circular}
      data-testid="chart-container"
    >
      <g>
        <circle className={styles.progress__circular__path} {...circleProps} />
        <circle
          className={styles.progress__circular__path__value}
          {...circleProps}
          strokeDasharray={circumference}
          strokeDashoffset={percentageValue}
        />
      </g>
    </svg>
  );
}
